module.exports = __webpack_public_path__ + "static/media/kneehyperextension_severe_right.19c980d6.png";